<template>
  <q-tabs v-model="tab" dense class="nav-tabs" active-color="primary" indicator-color="primary" align="left"
    narrow-indicator>
    <q-tab v-for="(item, index) in buildParties" :name="item.associatedParty.resourceUid"
      :label="$t(`demand.party.roles.${item.associatedParty.role_code}`)" :key="index" class="nav nav-item flex-grow-0" />
  </q-tabs>

  <q-tab-panels v-model="tab">
    <q-tab-panel v-for="(item, index) in buildParties" :name="item.associatedParty.resourceUid" :key="index"
      class="p-0 pt-3">
      <div v-if="item.associatedParty.third.objectType.includes('person')">
        <SummaryPerson :person="item.associatedParty.third.person" />
      </div>
      <div v-else>
        <SummaryOrganization :organization="item.associatedParty.third.organization" />
      </div>
    </q-tab-panel>
  </q-tab-panels>
</template>

<script lang="ts">
import SummaryPerson from "@/components/summary-panel/SummaryPerson.vue";
import SummaryOrganization from "@/components/summary-panel/SummaryOrganization.vue";
import { Options, Vue } from "vue-class-component";
import { OfferAssociatedParty } from "@/types";

@Options({
  components: { SummaryPerson, SummaryOrganization },
  props: ["arrParties"],
})
export default class SummaryTiers extends Vue {
  arrParties?: Array<OfferAssociatedParty>;
  tab?: string = "";
  filteredParties?: Array<OfferAssociatedParty>;
  get buildParties() {
    if (this.arrParties) {
      this.filteredParties = this.arrParties.filter((el) => el.role_code !== "DIRG");
      this.tab = this.filteredParties[0].associatedParty?.resourceUid;
      return this.filteredParties;
    }
    return [];
  }
}
</script>
